












































































import { Component, Prop, Vue } from "vue-property-decorator";
import MonitoringTrombolisisDetail from "./MonitoringTrombolisisDetail.vue";
import { storeMonitoringTrombolisis } from "@/store/modules/MonitoringTrombolisisStore";
import MonitoringTrombolisisSvc from "@/services/MonitoringTrombolisisService";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  components: {
    MonitoringTrombolisisDetail,
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class MonitoringTrombolisisList extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;

  showDetail = false;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("monitoring_trombolisis", "create");
  }

  mounted() {
    storeMonitoringTrombolisis.getByRegister(this.register);
  }

  get loading() {
    return storeMonitoringTrombolisis.loading;
  }

  get monitoring() {
    return storeMonitoringTrombolisis.currentItem;
  }

  tambah() {
    // Go directly to detail in create mode
    this.showDetail = true;
  }

  lihat() {
    this.showDetail = true;
  }

  cancelDetail() {
    this.showDetail = false;
  }

  onSaved() {
    storeMonitoringTrombolisis.getByRegister(this.register);
  }

  cetakPdf() {
    if (this.monitoring?.id) {
      MonitoringTrombolisisSvc.printPdf(this.monitoring.id);
    }
  }

  async hapus() {
    if (!this.monitoring?.id) return;
    const q = confirm("Anda yakin akan menghapus monitoring trombolisis ini?");
    if (q) {
      try {
        const resp = await MonitoringTrombolisisSvc.destroy(this.monitoring.id);
        if (resp?.data?.status == "1") {
          appModule.NoticeDelay("Berhasil menghapus");
          storeMonitoringTrombolisis.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
